import { render, staticRenderFns } from "./registerForms.vue?vue&type=template&id=9247ee7a&"
import script from "./registerForms.vue?vue&type=script&lang=js&"
export * from "./registerForms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports